module.exports = __webpack_public_path__ + "img/banner.a3b0bf53.webp";